export default __webpack_public_path__ + "static/mickleham-1-3e19e7b3c766724f496af697fbb32428.jpg";